import type { QueryClient } from "@tanstack/react-query";
import { WaiversPoliciesApi } from "@/openapi/generated";
import { QueryKeys } from "@/lib/types";
import { createOpenApiConfiguration } from "@/lib/utils";
import { resolveEffectiveTenantNumber } from "@/lib/utils/env/effective-tenant";

const DEFAULT_TENANT_ID = resolveEffectiveTenantNumber();
const PUBLIC_WAIVERS_PAGE = 1;
const PUBLIC_WAIVERS_PAGE_SIZE = 1000;

export async function prefetchWaiversPublic(
  queryClient: QueryClient,
  tenantId: number = DEFAULT_TENANT_ID,
) {
  const service = new WaiversPoliciesApi(createOpenApiConfiguration());

  await queryClient.prefetchQuery({
    queryKey: [QueryKeys.Waivers, tenantId, "public", PUBLIC_WAIVERS_PAGE, PUBLIC_WAIVERS_PAGE_SIZE],
    queryFn: () =>
      service.apiPoliciesScrollGet({
        page: PUBLIC_WAIVERS_PAGE,
        pageSize: PUBLIC_WAIVERS_PAGE_SIZE,
        active: true,
        xTenantID: tenantId,
      }),
    staleTime: 5 * 60 * 1000,
  });

  return queryClient;
}
